module.exports = __webpack_public_path__ + "img/w25-b4.9fae86f5.jpg";